import { createReducer } from '@mews/framework';
import { SALES_FORCE_CHAT_INITIALIZED, SALES_FORCE_CHAT_LOADED } from './actions';

const initialState = {
    isSalesForceLoaded: false,
    isSalesForceInitialized: false,
};

export default createReducer(initialState, {
    [SALES_FORCE_CHAT_LOADED]: (state: $TSFixMe) => ({
        ...state,
        isSalesForceLoaded: true,
    }),
    [SALES_FORCE_CHAT_INITIALIZED]: (state: $TSFixMe) => ({
        ...state,
        isSalesForceInitialized: true,
    }),
});
